<template>
  <div class="followlist">
    <div class="followlist-m">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline toolbar"
        style="padding-bottom:0px;"
        @submit.native.prevent
      >
        <el-form-item label="设备编号">
          <el-input
            v-model.trim="formInline.inputdeviceno"
            placeholder="请输入设备编号"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button  type="primary"
            icon="el-icon-search"
            plain @click="onSubmit"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="warning"
            plain
            class="el-icon-plus"
            @click="dialogFormVisible = true;"
            >新增</el-button
          >
          <el-button type="info" icon="el-icon-upload" plain @click="intoList"
            >导入</el-button
          >
          <el-button type="info" icon="el-icon-document" plain @click="downLoad"
            >表格模板下载</el-button
          >
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <div class="table-page">
          <el-table
            :data="list"
            style="width: 100%"
            :row-style="tableRowStyle"
            :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
            :header-cell-style="tableHeaderColor"
          >
            <el-table-column
              label="设备编号"
              align="center"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.deviceNo }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="设备名称"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{
                  scope.row.deviceName
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="设备描述"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.remark }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="绑定位置"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span
                  style="margin-left: 10px;color:orange;"
                  v-if="scope.row.location == null"
                  >暂未绑定</span
                >
                <span style="margin-left: 10px" v-else>{{
                  scope.row.location
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="400" align="center">
              <template slot-scope="scope">
                <!-- icon="el-icon-edit" -->
                <el-button
                  type="primary"
                  size="mini"
                  plain
                  @click="handleEdit(scope.$index, scope.row);"
                  >编辑</el-button
                >
                <!-- icon="el-icon-delete" -->
                <el-button
                  type="danger"
                  size="mini"
                  plain
                  @click="handleDelete(scope.$index, scope.row);"
                  >删除</el-button
                >
                <!-- icon="el-icon-goods" -->
                <el-button
                  type="success"
                  size="mini"
                  plain
                  v-if="scope.row.bindType == null"
                  @click="bindingEquipment(scope.$index, scope.row);"
                  >绑定</el-button
                >
                <!-- icon="el-icon-sold-out" -->
                <el-button
                  type="info"
                  size="mini"
                  plain
                  v-if="scope.row.bindType != null"
                  @click="handleJiebang(scope.$index, scope.row);"
                  >解绑</el-button
                >
                <!-- icon="el-icon-sold-out" -->
                <el-button
                  type="primary"
                  size="mini"
                  plain
                  @click="patrolBind(scope.$index, scope.row);"
                  >巡更棒绑定</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye"
        ></el-pagination>
      </div>
      <!-- 弹出新增 -->
      <el-dialog
        title="新增设备信息"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="followxz"
        @close="closexz"
      >
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item
            label="设备编号"
            :label-width="formLabelWidth"
            prop="xzdate"
          >
            <el-input
              v-model.trim="form.xzdate"
              placeholder="请输入设备编号"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="设备名称"
            :label-width="formLabelWidth"
            prop="xzname"
          >
            <el-input
              v-model.trim="form.xzname"
              placeholder="请输入设备名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="设备描述"
            :label-width="formLabelWidth"
            prop="xzsec"
          >
            <el-input
              v-model.trim="form.xzsec"
              type="textarea"
              :rows="3"
              placeholder="请输入设备描述"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="cancelxz">取 消</el-button>
          <el-button
            type="primary"
            @click="submitForm('form');"
            :loading="addLoading"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <!-- 弹出修改 -->
      <el-dialog
        title="修改设备信息"
        :visible.sync="dialogFormEdit"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="followedit"
      >
        <el-form ref="formedit" :model="formedit" :rules="rules">
          <el-form-item
            label="设备编号"
            :label-width="formLabelWidth"
            prop="editdate"
          >
            <el-input
              disabled
              v-model.trim="formedit.editdate"
              auto-complete="off"
              placeholder="请输入设备编号"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="设备名称"
            :label-width="formLabelWidth"
            prop="editname"
          >
            <el-input
              v-model.trim="formedit.editname"
              auto-complete="off"
              placeholder="请输入设备名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="设备描述"
            :label-width="formLabelWidth"
            prop="editsec"
          >
            <el-input
              v-model.trim="formedit.editsec"
              auto-complete="off"
              type="textarea"
              :rows="3"
              placeholder="请输入设备描述"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="dialogFormEdit = false;">取 消</el-button>
          <el-button
            type="primary"
            @click="submitFormEdit('formedit');"
            :loading="editLoading"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <!-- 弹出绑定设备 -->
      <el-dialog
        title="绑定巡更点"
        :visible.sync="dialogFormBangdi"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="bangdilocation"
        @close="closeBangdi"
        width="30%"
      >
        <el-form ref="formBangdi" :model="formBangdi" :rules="rules">
          <el-form-item
            label="设备编号 :"
            :label-width="formLabelWidth"
            prop="bindDeviceNo"
          >
            <span style="display: block;height:40px;line-height: 40px;">{{
              formBangdi.bindDeviceNo
            }}</span>
          </el-form-item>
          <el-form-item
            v-if="locationShow"
            label="绑定位置 :"
            :label-width="formLabelWidth"
            prop="location"
          >
            <el-input
              v-model.trim="formBangdi.location"
              auto-complete="off"
              style="width:220px;"
            ></el-input>
          </el-form-item>
          <!-- v-if="!locationShow" -->
          <el-form-item
            v-if="!locationShow"
            label="绑定位置 :"
            :label-width="formLabelWidth"
            prop="locationBedShow"
          >
            <span
              v-if="locationBedShow != ''"
              style="display: block;height:40px;line-height: 40px;"
              >{{ locationBedShow }}</span
            >
            <span v-else style="display: block;height:40px;line-height: 40px;"
              >暂无数据</span
            >
          </el-form-item>
          <el-form-item
            label="绑定类型 :"
            :label-width="formLabelWidth"
            prop="bindType"
          >
            <el-radio-group
              v-model="bindType"
              @change="changeRadioBindType"
              style="display: block;height:40px;line-height: 45px;"
            >
              <el-radio :label="0">自定义</el-radio>
              <!-- <el-radio :label="1">老人</el-radio> -->
              <el-radio :label="2">床位</el-radio>
              <el-radio :label="3">房间</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- v-if="bedShow" -->
          <el-form-item
            v-if="bindType == 2"
            label="床位号 ："
            :label-width="formLabelWidth"
            prop="bedId"
            style="display: block;height:40px;line-height: 40px;"
          >
            <el-cascader
              ref="refbed"
              :value="cascadervalue"
              :options="optionsBed"
              @active-item-change="handleItemChange"
              @change="handleChangeBed"
              key="optionsBed"
            ></el-cascader>
          </el-form-item>
          <!-- v-if="RoomShow" -->
          <el-form-item
            v-if="bindType == 3"
            label="房间号 ："
            :label-width="formLabelWidth"
            prop="roomId"
            style="height:40px;line-height: 40px;"
          >
            <el-cascader
              ref="refroom"
              :value="cascadervalueRoom"
              :options="optionsRoom"
              @change="handleChangeRoom"
              key="cascadervalueRoom"
            ></el-cascader>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="cancelBangdi">取 消</el-button>
          <el-button type="primary" @click="submitFormBind('formBangdi');"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <!-- 弹出绑定巡更棒 -->
      <el-dialog
        title="巡更点绑定巡更棒"
        :visible.sync="dialogFormPatrolBind"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="50%"
      >
        <div style="text-align: center">
          <el-transfer
            style="text-align: left; display: inline-block"
            v-model="bindingBodyList"
            filterable
            :left-default-checked="[1]"
            :right-default-checked="[1]"
            :titles="['未绑定的巡更棒', '已绑定的巡更棒']"
            :button-texts="['删除', '添加']"
            :format="{
              noChecked: '${total}',
              hasChecked: '${checked}/${total}'
            }"
            ref="myTransfer"
            @change="transferChange"
            :data="unbindBodyList"
          >
            <el-tooltip
              slot-scope="{
                option
              }"
              class="item"
              effect="dark"
              :content="option.label"
              placement="right"
            >
              <div class="transferOption">{{ option.label }}</div>
            </el-tooltip>
          </el-transfer>
        </div>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="dialogFormPatrolBind = false;">取 消</el-button>
          <el-button
            type="primary"
            @click="bangdingFormBody('formBind');"
            :loading="patrolBindLoading"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <!-- 表格导入的dialog -->
      <el-dialog
        title="设备导入"
        width="30%"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        @close="closeDialogReset"
      >
        <el-row type="flex" justify="center">
          <el-col :span="20">
            <el-row>
              <el-col :span="24">
                <input type="file" ref="file" id="file" @change="getUrl" />
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click.native="dialogVisible = false;">取消</el-button>
          <el-button type="primary" @click.native="intoForm">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import iTable from "@/components/iTable.vue";
import { baseURL } from "@/utils/request.js";
export default {
  data() {
    return {
      addLoading: false,
      editLoading: false,
      BindLoading: false,
      patrolBindLoading: false,
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 8, //每页显示的条数
      deviceno: "",
      list: [], //返回的结果集合
      totalDataNumber: 0, //数据的总数,
      loading: "", //加载数据中
      formInline: {
        inputdeviceno: ""
      },
      // 新增表单dialog
      dialogFormVisible: false,
      dialogVisible: false,
      form: {
        xzdate: "",
        xzsec: "",
        xzname: ""
      },
      formLabelWidth: "120px",
      //修改表单dialog
      dialogFormEdit: false,
      formedit: {
        editdate: "",
        editname: "",
        editsec: ""
      },
      //绑定设备表单dialog
      // dialogFormBind: false,
      // formbind: {
      //   binddate: "",
      //   bindname: "",
      //   bindType: 2,
      //   bindsec: ""
      // },
      //绑定位置 ， 自定义 老人和床位
      dialogFormBangdi: false,
      locationShow: true, //绑定床位的input 和 span 显示和隐藏的切换
      oldManShow: false, //选择老人的显示和隐藏
      bedShow: false, //选择床位信息的显示和隐藏
      locationBedShow: "", //如果是绑定类型为床位绑定   就把Cascader级联选择器选择的楼栋 层数 房间 床位  回显放到location绑定的位置
      cascadervalue: [], //Cascader级联选择器集合的值默认为空
      optionsBed: [], //床位号的Cascader级联选择器集合
      bindType: 0, //设备绑定的类型
      formBangdi: {
        location: "", //绑定的位置
        deviceId: "", //设备id
        bedId: "", //床位id
        roomId: "", //房间id
        bindDeviceNo: "" //绑定模态框弹出的设备编号
      },
      cascadervalueRoom: [],
      optionsRoom: [], //楼栋层数房间
      RoomShow: false,
      rules: {
        // 新增正则验证匹配规则
        xzdate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          },
          //可以设置双重验证标准
          //{min: 5, max:15, message: '长度在 5到 15 个字符'},
          // { pattern: /^[A-Za-z0-9_]+$/, message: '请输入由数字、字母、下划线组成的字符' }
          //{ pattern: /^[a-z0-9_-]+$/gi, message: '请输入由数字,大小写字母和_或-组成的字符' },
          //{ pattern: /^HC/, message: '请输入由HC开头的字符' }
          { min: 1, max: 30, message: "长度在 1到 30 个字符" } //by  guo 2020-4-26-18:12修改
        ],
        xzname: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 30, message: "长度在 1到 30 个字符" }
        ],
        xzsec: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 100, message: "长度在 1到 100 个字符" }
        ],

        // 修改正则验证匹配规则
        editdate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          },
          //可以设置双重验证标准
          //{ min: 5, max:15,  message: '长度在 5到 15 个字符', },
          // { pattern: /^[A-Za-z0-9_]+$/, message: '请输入由数字、字母、下划线组成的字符' }
          //{ pattern: /^[a-z0-9_-]+$/gi, message: '请输入由数字,大小写字母和_或-组成的字符' }
          // { pattern: /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[_-])[a-z0-9_-]+$/gi, message: '请输入由数字,大小写字母和_或-组成的字符' }
          { min: 1, max: 30, message: "长度在 1到 30 个字符" } //by  guo 2020-4-26-18:12修改
        ],

        editname: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 30, message: "长度在 1到 30 个字符" }
          // { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊符号' }
        ],
        editsec: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 100, message: "长度在 1到 100 个字符" }
          // { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊符号' }
        ],
        binddate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          }
          //可以设置双重验证标准
        ],
        // bindType: [
        //   {
        //     required: true, //是否必填
        //     message: "不能为空", //规则
        //     trigger: "blur" //何事件触发
        //   }
        // ],
        location: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          },
          { min: 1, max: 15, message: "长度在 1到 15 个字符" }
        ],
        oldmanName: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "change" //何事件触发
          }
        ],
        bedId: [
          {
            required: true, //是否必填
            message: "还未选择床位", //规则
            trigger: "change" //何事件触发
          }
        ],
        roomId: [
          {
            required: true, //是否必填
            message: "还未选择房间", //规则
            trigger: "change" //何事件触发
          }
        ]
      },
      fileFlag: false,
      //网关绑定设备的dialog模态框配置
      gatewayId: "",
      pointNo: "",
      dialogFormPatrolBind: false,
      // allUnbindBodyList: [], //所有未绑定的人体感应
      bindingBodyList: [], //穿梭框右边的数据 已绑定的人感
      unbindBodyList: [] //穿梭框左边的数据 未绑定的人感
    };
  },
  methods: {
    // 选中行
    handleSelectionChange(val) {
      console.log("val:", val);
    },

    //点击查询
    onSubmit(newVal, oldVal) {
      console.log(newVal, oldVal);
      if (this.formInline.inputdeviceno == "") {
        this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
      } else {
        this.getTableData(
          this.formInline.inputdeviceno,
          (this.pageNum = 1),
          (this.pageSize = 8)
        );
      }
    },

    //键盘事件 按下键盘回车 查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.formInline.inputdeviceno != null) {
        if (this.formInline.inputdeviceno == "") {
          this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
        } else {
          this.getTableData(
            this.formInline.inputdeviceno,
            (this.pageNum = 1),
            (this.pageSize = 8)
          );
        }
      }
    },
   // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },

    //查询所有楼栋,层 ,房间 ,床位
    getBuildingShowAll() {
      let parma = {
        buildingName: "" //楼栋名称
      };
      this.$postForm("omc/Building/showAlls", parma).then(res => {
        console.log(res);
        if (res.result != null) {
          res.result.forEach((item, index) => {
            console.log(item);
            var floorList = [];
            this.optionsBed.push({
              value: item.buildingId,
              label: item.buildingName,
              children: floorList
            });
            //2层循环取出楼层信息 判断是否存在
            if (item.floorList != null) {
              item.floorList.forEach((item2, index) => {
                var roomList = [];
                floorList.push({
                  value: item2.floorNo,
                  label: item2.floorNo + "层",
                  children: roomList
                });
                //3层循环取出房间roomId 判断是否存在
                if (item2.roomList != null) {
                  item2.roomList.forEach((item3, index) => {
                    var bedList = [];
                    roomList.push({
                      value: item3.roomId,
                      label: item3.roomNo,
                      children: bedList
                    });
                    //4层循环取出床位bedId 判断是否存在
                    if (item3.bedList != null) {
                      item3.bedList.forEach((item4, index) => {
                        bedList.push({
                          value: item4.bedId,
                          label: item4.bedNo + "号床"
                        });
                      });
                    }
                  });
                }
              });
            }
          });
        }
      });
    },

    //查询所有楼栋,层 ,房间
    getBuildingShowAllRoom() {
      let parma = {
        buildingName: "" //楼栋名称
      };
      this.$postForm("omc/Building/showAlls", parma).then(res => {
        console.log(res);
        //1层循环取出楼栋信息  判断是否存在
        if (res.result != null) {
          res.result.forEach((item, index) => {
            console.log(item, index);
            var floorList = [];
            this.optionsRoom.push({
              value: item.buildingId,
              label: item.buildingName,
              children: floorList
            });
            //2层循环取出楼层信息  判断是否存在
            if (item.floorList != null) {
              item.floorList.forEach((item2, index) => {
                var roomList = [];
                floorList.push({
                  value: item2.floorNo,
                  label: item2.floorNo + "层",
                  children: roomList
                });
                //3层循环取出房间roomId 判断是否存在
                if (item2.roomList != null) {
                  item2.roomList.forEach((item3, index) => {
                    roomList.push({
                      value: item3.roomId,
                      label: item3.roomNo
                    });
                  });
                }
              });
            }
          });
        }
      });
    },

    //选取的房间
    handleChangeRoom(val) {
      console.log(val);
      this.formBangdi.roomId = val[2]; //获取房间roomId
      if (val.length == 3) {
        console.log(this.$refs.refroom.currentLabels);
        var refroomStr = "";
        this.$refs.refroom
          .getCheckedNodes()[0]
          .pathLabels.forEach((item, index) => {
            //判断字符串拼接最后一位不加 "-"
            if (
              this.$refs.refroom.getCheckedNodes()[0].pathLabels.length - 1 ==
              index
            ) {
              refroomStr += item;
            } else {
              refroomStr += item + "-";
            }
          });
        this.locationBedShow = refroomStr; //把获取的床位信息回显到location位置
        console.log(this.locationRoomShow);
      } else {
        this.locationBedShow = "暂无数据";
      }
    },
    // 绑定类型选择
    changeRadioBindType(value) {
      console.log(value, "value");
      this.$refs.formBangdi.clearValidate(); //移除校验结果并重置字段值
      // 收起级联选择器
      // this.$refs.refbed.dropDownVisible = false;
      // this.$refs.refroom.dropDownVisible = false;
      this.locationBedShow = "暂无数据"; //选取自定义时清空绑定位置信息
      this.$refs.formBangdi.clearValidate(); //移除校验结果并重置字段值
      if (value == 0) {
        this.RoomShow = false;
        this.oldManShow = false;
        this.bedShow = false;
        this.locationShow = true;
        this.$set(this.rules, "location", [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          },
          {
            min: 1,
            max: 30,
            message: "长度在 1到 30 个字符"
          }
        ]);
        this.formBangdi.bedId = null; //选取自定义时清空房间的信息
      } else if (value == 2) {
        this.oldManShow = false;
        this.bedShow = true;
        this.RoomShow = false;
        this.locationShow = false;
      } else if (value == 3) {
        this.RoomShow = true;
        this.oldManShow = false;
        this.bedShow = false;
        this.locationShow = false;
      }
    },
    //关闭绑定dialog  重置
    closeBangdi(formName) {
      this.dialogFormBangdi = false;
      this.cascadervalue = []; //绑定成功后清空Cascader级联选择器框的值
      this.cascadervalueRoom = [];
      this.locationBedShow = "暂无数据";
      this.$refs.formBangdi.clearValidate(); //移除校验结果并重置字段值
      if (this.bindType != 0) {
        //点击取消关闭 重置dialog的状态
        this.bindType = 0;
        this.oldManShow = false;
        this.bedShow = false;
        this.locationShow = true;
        this.$set(this.rules, "location", [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          },
          {
            min: 1,
            max: 30,
            message: "长度在 1到 30 个字符"
          }
        ]);
      }
    },

    //取消  弹出框关闭
    cancelBangdi() {
      this.dialogFormBangdi = false;
      this.cascadervalue = []; //绑定成功后清空Cascader级联选择器框的值
      this.locationBedShow = "暂无数据";
      this.$refs.formBangdi.clearValidate(); //移除校验结果并重置字段值
      if (this.bindType != 0) {
        //点击取消关闭 重置dialog的状态
        this.bindType = 0;
        this.oldManShow = false;
        this.bedShow = false;
        this.locationShow = true;
        this.$set(this.rules, "location", [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          },
          {
            min: 1,
            max: 30,
            message: "长度在 1到 30 个字符"
          }
        ]);
      }
    },
    // 绑定设备
    bindingEquipment(index, row) {
      //点击绑定打开dialog 在清除input绿色框  先判断是否为undefined
      if (this.$refs["formBangdi"] != undefined) {
        this.$nextTick(() => {
          this.$refs["formBangdi"].resetFields();
        });
      }
      console.log(index, row);
      this.dialogFormBangdi = true;
      this.formBangdi = Object.assign({}, row); //深拷贝数据
      console.log(this.formBangdi.id);
      this.formBangdi.deviceId = this.formBangdi.id;
      this.formBangdi.bindDeviceNo = this.formBangdi.deviceNo;
      // this.$router.push({path:'/bangdibutton',query:{id:id}});//编程式导航跳转  query传参
    },
    //选取的当前的楼栋 层 房间
    handleItemChange(val) {
      console.log("active item:", val);
    },
    //选取的床位
    handleChangeBed(val) {
      console.log(val);
      this.formBangdi.bedId = val[3]; //获取房间roomId
      if (val.length == 4) {
        console.log(this.$refs.refbed.currentLabels);
        var refbedStr = "";
        this.$refs.refbed
          .getCheckedNodes()[0]
          .pathLabels.forEach((item, index) => {
            //判断字符串拼接最后一位不加 "-"
            if (
              this.$refs.refbed.getCheckedNodes()[0].pathLabels.length - 1 ==
              index
            ) {
              refbedStr += item;
            } else {
              refbedStr += item + "-";
            }
          });
        this.locationBedShow = refbedStr; //把获取的床位信息回显到location位置
        console.log(this.locationBedShow);
        //通过床位查找老人id,判断该床位是否有老人入住
        if (this.formBangdi.bedId) {
          //判断床位是否被选中 ,选中了才赋值  发起数据请求
          let param = {
            bedId: this.formBangdi.bedId
          };
          console.log(param);
          this.$postForm("omc/Bed/selectByBedId", param).then(res => {
            console.log(res);
            if (res.result.oldmanId != null) {
              this.formBangdi.oldmanId = res.result.oldmanId;
              console.log(this.formBangdi.oldmanId);
            } else {
              this.formBangdi.oldmanId = null;
            }
          });
        }
      } else {
        this.locationBedShow = "暂无数据";
      }
    },

    // 解绑设备
    handleJiebang(index, row) {
      console.log(row, "row");
      this.$confirm("此操作将解除绑定, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        closeOnClickModal: false
      })
        .then(() => {
          // this.formBangdi = Object.assign({}, row); //拷贝数据
          let params = {
            deviceId: Number(row.id)
          };
          this.$postJson("dmc/patrolPoint/untied", params).then(res => {
            console.log(res);
            this.$set(this.formedit, "status", true);
            this.getTableData();
            if (res.code == 200) {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "success"
                });
              }, 300);
            } else {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "error"
                });
              }, 300);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消解除绑定"
          });
        });
    },
    // 巡更棒绑定
    patrolBind(index, row) {
      this.gatewayId = row.id;
      this.pointNo = row.deviceNo;
      this.dialogFormPatrolBind = true;
      //每次打开先清空数据
      this.bindingBodyList = [
        //   { key: 1, value: 1, label: "已绑定1" },
        //   { key: 2, value: 2, label: "已绑定2" }
      ]; //穿梭框右边的数据 已绑定的巡更棒

      this.unbindBodyList = [
        //   { key: 1, value: 1, label: "未绑定1" },
        //   { key: 2, value: 2, label: "未绑定2" }
      ]; //穿梭框左边的数据 未绑定的巡更棒
      // this.unbindBodyList.forEach(item => {
      //   if (item.key == 1) {
      //     this.bindingBodyList.push(item.value * 1);
      //   }
      // });

      this.getBodyList(row.id);
    },

    // 点击弹出修改信息的弹窗
    handleEdit(index, row) {
      (this.dialogFormEdit = true), //打开修改弹窗
        console.log(index, row);
      this.listIndex = index; //记录索引
      console.log(this.listIndex);
      // this.formedit=row;//记录数据
      this.formedit = Object.assign({}, row); //深拷贝记录
      console.log(this.formedit.id);
      //将对应行所对的表格值赋给input框
      this.$set(this.formedit, "editdate", row.deviceNo);
      this.$set(this.formedit, "editsec", row.remark);
      this.$set(this.formedit, "editname", row.deviceName);
      console.log(this.formedit.editdate);
    },

    //点击修改弹窗的 确定按钮提交修改的数据
    submitFormEdit(datainfo) {
      //正则匹配规则rules
      this.$refs[datainfo].validate(valid => {
        //判断数据是否存在
        if (valid) {
          let param = {
            id: this.formedit.id,
            remark: this.formedit.editsec,
            deviceName: this.formedit.editname,
            deviceNo: this.formedit.editdate
          };
          console.log(param);
          this.editLoading = true;
          this.$postJson("dmc/patrolPoint/update", param).then(res => {
            console.log(res);
            this.editLoading = false;
            this.dialogFormEdit = false; //关闭修改弹窗
            this.$bus.$emit("submitFormEditchange_follow"); //发送一个change事件
            if (res.code == "200") {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "success"
                });
              }, 300);
              console.log("修改成功!");
            } else {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "error"
                });
              }, 300);
            }
            //console.log(this.$store.state.count)
          });
        } else {
          console.log("修改失败!");
          return false;
        }
      });
    },

    //删除
    handleDelete(index, row) {
      if (row.bindType == null) {
        this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          closeOnClickModal: false
        })
          .then(() => {
            console.log(index, row);
            let id = row.id;
            console.log(id);
            this.$postJson(`dmc/propertyManagement/untie`, {
              deviceIds: [id]
            }).then(res => {
              //旧 dmc/follow/deleteById/
              if (res.code == 200) {
                this.$bus.$emit("handleDeletechange_follow"); //发送一个change事件
                console.log(res);
                this.$message({
                  type: "success",
                  message: res.message
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      } else {
        this.$message({
          type: "error",
          message: "该设备已经被绑定，请先解绑后再进行删除!"
        });
      }
    },

    //关闭新增的dialog
    closexz() {
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    //点击新增取消  重置表单以及验证
    cancelxz() {
      this.dialogFormVisible = false;
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    //新增弹出框点击确定提交信息
    submitForm(datainfo) {
      this.$refs[datainfo].validate(valid => {
        if (valid) {
          let param = {
            remark: this.form.xzsec,
            deviceName: this.form.xzname,
            deviceNo: this.form.xzdate
          };
          console.log(param);
          //this.loading = true
          this.addLoading = true;
          this.$postJson("dmc/propertyManagement/bindDeviceMerchant", param)
            .then(res => {
              //旧: dmc/follow/add
              console.log(res);
              this.addLoading = false;
              this.dialogFormVisible = false;
              this.$refs.form.resetFields(); //移除校验结果并重置字段值
              this.$bus.$emit("submitFormchange_follow"); //发送一个change事件
              if (res.code == "200") {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "success"
                  });
                }, 300);
                console.log("提交成功!");
              } else {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "error"
                  });
                }, 300);
              }
              //console.log(this.$store.state.count)
              //this.loading = false
            })
            .catch(res => {
              this.$message({
                type: "error",
                message: res.message
              });
            });
        } else {
          console.log("提交失败!");
          return false;
        }
      });
    },
    // 绑定设备弹窗提交
    submitFormBind(datainfo) {
      this.$refs[datainfo].validate(valid => {
        if (valid) {
          let param = "";
          console.log(this.bindType, "sssssssssssssss");
          if (this.bindType == 0) {
            param = {
              deviceId: this.formBangdi.deviceId,
              bindType: this.bindType,
              location: this.formBangdi.location
            };
          } else if (this.bindType == 1) {
            param = {
              deviceId: this.formBangdi.deviceId,
              bindType: this.bindType,
              location: this.formBangdi.location,
              oldmanId: this.formBangdi.oldmanId,
              oldmanName: this.formBangdi.oldmanName
            };
          } else if (this.bindType == 2) {
            param = {
              deviceId: this.formBangdi.deviceId,
              bindType: this.bindType,
              location: this.locationBedShow,
              oldmanId: this.formBangdi.oldmanId,
              bedId: this.formBangdi.bedId
            };
          } else if (this.bindType == 3) {
            param = {
              deviceId: this.formBangdi.deviceId,
              bindType: this.bindType,
              location: this.locationBedShow,
              roomId: this.formBangdi.roomId
            };
          }
          console.log(param, "paramparam");
          this.$postJson("dmc/patrolPoint/bind", param)
            .then(res => {
              //旧: dmc/follow/add
              console.log(res);
              this.BindLoading = false;
              this.dialogFormBangdi = false;
              this.$refs[datainfo].resetFields(); //移除校验结果并重置字段值
              this.$bus.$emit("submitFormchange_follow"); //发送一个change事件
              if (res.code == "200") {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "success"
                  });
                }, 300);
                console.log("提交成功!");
              } else {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "error"
                  });
                }, 300);
              }
              //console.log(this.$store.state.count)
              //this.loading = false
            })
            .catch(res => {
              this.$message({
                type: "error",
                message: res.message
              });
            });
        } else {
          console.log("提交失败!");
          return false;
        }
      });
    },
    transferChange(value, direction, movedKeys) {
      console.log(value, direction, movedKeys);
      this.deviceIdList = value; //获取需要提交的数据源
      console.log(this.deviceIdList);
    },
    /*
      绑定 巡更棒 提交数据
    */
    bangdingFormBody() {
      
      let params = {};
      params.pointId = this.gatewayId; //巡更点id
      params.pointNo = this.pointNo; //巡更点编号
      var greatIds = new Array();
      // greatIds =
      //   this.deviceIdList != [] ? this.deviceIdList : this.bindingBodyList; //判断一下 没有选择就提交右边已经绑定的数据
      greatIds = this.bindingBodyList; //判断一下 没有选择就提交右边已经绑定的数据
      params.greatIds = greatIds;
      // 没有就不传数组
      if (params.greatIds) {
        if (params.greatIds.length == 0) {
          params = {
            pointId: this.gatewayId, //巡更点id
            pointNo: this.pointNo //巡更点编号
          };
        }
      }
      console.log(params);
      let url = "dmc/patrolPoint/bindPatrol";
      console.log(url, this.deviceType);
      this.$postJson(url, params, this.acceptLanguage).then(res => {
        if (res.code == 200) {
          this.$message({ message: res.message, type: "success" });
          this.dialogVisibleBody = false;
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
        this.getBodyList(this.gatewayId);
      });
    },
    /*
      获取人感 或者 温湿度计 穿梭框数据
    */
    getBodyList(gatewayId) {
      this.unbindBodyList = [];
      this.bindingBodyList = [];
      let params = {};
      params.deviceId = gatewayId;
      (params.pageSize = 999), (params.pageNum = 1);
      console.log(params);
      // 查询所有未绑定的巡更棒
      this.$postJson("dmc/patrol/selectUntiedPatrol", params)
        .then(res => {
          if (res.result.length > 0) {
            res.result.forEach((item, index) => {
              console.log(item);
              let bodyObj = {};
              bodyObj.key = item.deviceId * 1; //巡更棒 deviceId
              bodyObj.label = item.deviceNo; //巡更棒 编号
              this.unbindBodyList.push(bodyObj); //穿梭框左边的数据源  未绑定的巡更棒
            });
             // 去重
            this.unbindBodyList = Array.from(new Set(this.unbindBodyList));
          }
          console.log(
            this.unbindBodyList,
            "unbindBodyListunbindBodyListunbindBodyList"
          );
        })
        .then(
          // 查询已经绑定的巡更棒
          this.$postJson("dmc/patrol/selectBindPatrol", {
            id: gatewayId
          }).then(res => {
            if (res.result.length > 0) {
              res.result.forEach((item, index) => {
                console.log(item);
                this.bindingBodyList.push(item.deviceId * 1);
              });
              // 去重
              this.bindingBodyList = Array.from(new Set(this.bindingBodyList));
            }
            console.log(this.bindingBodyList, "bindingBodyListbindingBodyList");
          })
        );
    },
    //获取表格数据
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        deviceNo: this.formInline.inputdeviceno
      };
      console.log(param);
      this.loading = true;
      this.$postJson(
        "dmc/patrolPoint/queryGroupPatrolPointListWithPage",
        param
      ).then(res => {
        console.log(res);
        //判断是否有数据
        if (res.result.list.length != 0) {
          this.pageSize = res.result.pageSize;
          this.currentPage = res.result.pageNum;
          this.totalDataNumber = res.result.total * 1;
          this.list = res.result.list;
          //this.$set(this.tableData,res.result.list)
          console.log(this.list);
          setTimeout(() => {
            this.loading = false;
          }, 500);
        } else {
          this.list = [];
          this.totalDataNumber = 0;
          setTimeout(() => {
            this.loading = false;
          }, 3000);
        }
      });
    },

    //导入
    intoList() {
      this.dialogVisible = true;
    },

    //确认导入
    getUrl(event) {
      let file = event.target.files;
      console.log(file);
      this.fileFlag = true; //by guo 2020-8-4-15:18添加
      this.formData = new FormData();
      this.formData.append("file", file[0]);
    },

    //确认导入
    intoForm() {
      if (this.fileFlag) {
        this.$postFormData(
          "dmc/propertyManagement/patrolPointToLead",
          this.formData
        ).then(res => {
          this.dialogVisible = false;
          this.formData = {};
          this.fileFlag = false;
          if (res.code == 200) {
            this.$message({ message: res.message, type: "success" });
            this.getTableData();
          } else {
            this.$message({ message: res.message, type: "error" });
          }
        });
      } else {
        this.$message({ message: "请选择文件", type: "error" });
      }
    },

    closeDialogReset() {
      this.$refs.file.value = ""; // 清空file文件
    },

    //模板下载
    downLoad() {
      window.location.href = baseURL + "dmc/api/downPointTemplate";
    },

    //初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getTableData();
    }
  },

  watch: {
    currentPage(newV, oldV) {
      console.log(newV, oldV);
      deep: true; //深度监听
    },
    //  tableData(newV,oldV) {
    //      console.log(newV,oldV);
    //      deep: true  //深度监听
    // },
    data: "onSubmit" //值可以为methods的方法
  },

  created() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.getTableData();
    this.getBuildingShowAll();
    this.getBuildingShowAllRoom();
  },

  mounted() {
    //监听submitFormchange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
    this.$bus.$on("submitFormchange_follow", () => {
      this.getTableData();
    }),
      //监听handleDeletechange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
      this.$bus.$on("handleDeletechange_follow", () => {
        this.getTableData();
      }),
      //监听submitFormEditchange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
      this.$bus.$on("submitFormEditchange_follow", () => {
        this.getTableData();
      }),
      this.getTableData();
  },
  components: { iTable }
};
</script>
<style lang="scss" scoped>
.followlist {
  .followlist-m {
    padding: 10px 0 0 5px;
  }
}

// 修改element-ui默认的样式
.del {
  color: red !important;
}
.fangqu {
  color: green !important;
}
.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}
//  ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}

//新增的dialog
@media screen and (min-width: 1200px) {
  ::deep .followxz .el-dialog {
    width: 30% !important;
  }
}

//修改的dialog
@media screen and (min-width: 1200px) {
  ::deep .followedit .el-dialog {
    width: 30% !important;
  }
}
::deep .transferOption {
  width: 120px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::deep
  .el-transfer-panel
  .el-transfer-panel__header
  .el-checkbox
  .el-checkbox__label {
  font-size: 12px !important;
}
</style>
